import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getUserDiaryAPI, deleteDiaryAPI } from '../api/diary';
import { getManagerMode, getManagerRobotId, getUserPId } from '../common/util';

const MODULE_DIARY = 'diaryBot';
const initialState = {
  loading: false,
  pending: false,
  lists: [],
  listLength: 0,
  total: 0,
  error: null,
  delete: { result: false, message: null },
};

export const getData = createAsyncThunk(
  `${MODULE_DIARY}/getData`,
  async (params, { rejectWithValue, getState }) => {
    try {
      const conditions = { ...params, userId: getUserPId() };
      if (getManagerMode()) {
        conditions.robotId = getManagerRobotId();
      }
      const { result, list: data, total } = await getUserDiaryAPI(conditions);
      if (result) {
        const { skip, limit } = conditions;
        const { lists: prevLists, listLength: prevListLength } =
          getState()[MODULE_DIARY];
        const listLength = total > skip + limit ? skip + limit : total;
        if (skip && skip === prevListLength) {
          const [[date, list]] = Object.entries(data[0]);

          const newLists = prevLists.reduce((acc, cur, idx, self) => {
            if (self.length - 1 === idx) {
              const [[d, ls]] = Object.entries(cur);
              if (d === date) {
                data.splice(0, 1);
                return [...acc, { [d]: ls.concat(list) }].concat(data);
              }
              return [...acc, ...data];
            }
            return [...acc, cur];
          }, []);
          return { lists: newLists, total, listLength };
        }
        return { lists: data, total, listLength };
      }
      return rejectWithValue('음성일기 목록 로드 중 오류가 발생했습니다.');
    } catch (error) {
      return rejectWithValue('음성일기 목록 로드 중 오류가 발생했습니다.');
    }
  },
);

export const deleteItem = createAsyncThunk(
  `${MODULE_DIARY}/delete`,
  async (diary, { rejectWithValue }) => {
    try {
      const { result, error } = await deleteDiaryAPI({
        userPId: getUserPId(),
        diary,
      });
      if (result) return result;
      if (error) return rejectWithValue(error.desc);
      return rejectWithValue('음성일기 삭제 중 오류가 발생했습니다.');
    } catch (error) {
      return rejectWithValue('음성일기 삭제 중 오류가 발생했습니다.');
    }
  },
);

const diarySlice = createSlice({
  name: MODULE_DIARY,
  initialState,
  reducers: {
    init: () => ({ ...initialState }),
  },
  extraReducers: {
    [getData.pending.type]: (state) => ({ ...state, loading: true }),
    [getData.fulfilled.type]: (state, action) => ({
      ...state,
      loading: false,
      ...action.payload,
    }),
    [getData.rejected.type]: (state, action) => ({
      ...state,
      loading: false,
      error: action.payload,
    }),
    [deleteItem.pending.type]: (state) => ({
      ...state,
      pending: true,
      delete: { result: null, message: null },
    }),
    [deleteItem.fulfilled.type]: (state) => ({
      ...state,
      pending: false,
      delete: { result: true, message: '음성일기를 삭제했습니다.' },
    }),
    [deleteItem.rejected.type]: (state, action) => ({
      ...state,
      pending: false,
      delete: { result: false, message: action.payload },
    }),
  },
});

const { reducer: DiaryReducer, actions } = diarySlice;
export const { init } = actions;

export default DiaryReducer;
